import React from 'react';
import Item from './Item';
import styles from './index.module.scss';
const Advantages = ({ items }) => {
    return (React.createElement("ul", { className: styles.wrapper }, items.map((item) => (React.createElement(Item, { key: item.text, icon: item.icon, text: item.text })))));
};
export default Advantages;
